export const REPORT_TYPES = [
  { value: 'cobranza', label: 'Cobranza' },
  { value: 'ajusteDePlan', label: 'Ajuste de plan' },
  { value: 'cancelarSuscripcion', label: 'Cancelar suscripción' },
  { value: 'menuDePlick', label: 'Menú de Plick' },
  { value: 'comandero', label: 'Comandero' },
  { value: 'panelDeAdministracion', label: 'Panel de Administración' },
  { value: 'aplicacionDeWindows', label: 'Aplicación de Windows' },
  { value: 'aplicacionDeAndroid', label: 'Aplicación de Android' },
  { value: 'pagosEnLinea', label: 'Pagos en línea' },
  { value: 'proveedoresDeReparto', label: 'Proveedores de reparto' },
] as const;

import { Commerce } from '@interfaces/general';

export interface ReportFormData {
  merchantId: string;
  reportTypeCode: string;
  customTypeText?: string;
  description: string;
  commerce?: Commerce;
}

export interface ReportFormErrors {
  reportTypeCode?: string;
  customTypeText?: string;
  description?: string;
}

export const MIN_DESCRIPTION_LENGTH = 10;
export const MAX_DESCRIPTION_LENGTH = 2000;
